export default "__VITE_ASSET__80f0d08f__"